import { Pipe, PipeTransform } from '@angular/core';
import { Duration } from 'luxon';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'formatDuration',
  standalone: true,
  pure: true,
})
export class FormatDurationPipe implements PipeTransform {
  constructor(private readonly transloco: TranslocoService) {}

  transform(minutes: number | null | undefined): string | null {
    if (minutes == null) return null;

    const locale = this.transloco.getActiveLang();
    const duration = Duration.fromObject({ minutes }).shiftTo('hours', 'minutes');
    const hours = Math.floor(duration.hours);
    const remainingMinutes = Math.round(duration.minutes);
    const formatNumber = (value: number) => new Intl.NumberFormat(locale).format(value);

    if (hours > 0 && remainingMinutes > 0) {
      return `${formatNumber(hours)}h${remainingMinutes.toString().padStart(2, '0')}`;
    }
    if (hours > 0) {
      return `${formatNumber(hours)}h`;
    }
    return `${formatNumber(remainingMinutes)} min`;
  }
}
